








import { Component, Prop, Vue } from 'vue-property-decorator';

import Wrapper from '@/components/layout/Wrapper.vue';
import CoverSection, { CoverVersion } from '@/components/homescapes/hs002/CoverSection.vue';
import PageFooter from '@/components/common/PageFooter.vue';

const versions: Record<string, CoverVersion> = {
  1: CoverVersion.HOME,
  2: CoverVersion.KATHERIN,
  3: CoverVersion.PAINT,
  default: CoverVersion.HOME,
};

@Component({
  components: {
    Wrapper,
    CoverSection,
    PageFooter,
  },
})
export default class HS002 extends Vue {
  @Prop({ type: Number })
  readonly version?: number;

  get cover() {
    return (this.version && versions[this.version]) || versions.default;
  }
}
